import SS7RaffleSignupPage from 'containers/ss7-raffle-signup'

export default SS7RaffleSignupPage

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'Snapshot VII Event Raffle',
  },
})
